package dev.inmo.wishlist.features.ui.users.ui

import dev.inmo.wishlist.features.common.client.models.ViewConfig
import kotlinx.serialization.Serializable

/** Navigation config for the users list — root of the scaffold main slot chain. */
@Serializable
class UsersListViewConfig : ViewConfig
